/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Rareachievementstitle2Inputs */

const id_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian Langka`)
};

const ms_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian Jarang`)
};

const da_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjældne Achievements`)
};

const de_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seltene Errungenschaften`)
};

const en_us2_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rare Achievements`)
};

const es_es2_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros raros`)
};

const es_mx2_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros raros`)
};

const fil_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Bihirang Achievement`)
};

const fr_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès rares`)
};

const it_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati rari`)
};

const hu_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritka teljesítmények`)
};

const nl_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeldzame prestaties`)
};

const no_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjeldne prestasjoner`)
};

const pl_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rzadkie osiągnięcia`)
};

const pt_br2_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas Raras`)
};

const pt_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas raras`)
};

const ro_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizări rare`)
};

const fi_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvinaiset saavutukset`)
};

const sv_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sällsynta prestationer`)
};

const vi_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích hiếm`)
};

const tr_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadir Başarımlar`)
};

const cs_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzácné úspěchy`)
};

const bg_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редки постижения`)
};

const ru_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редкие достижения`)
};

const uk_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рідкісні досягнення`)
};

const ar_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنجازات النادرة`)
};

const hi_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दुर्लभ उपलब्धियाँ`)
};

const th_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จหายาก`)
};

const ja_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レア実績`)
};

const zh_cn2_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀有成就`)
};

const zh_hant1_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稀有成就`)
};

const ko_profile_showcase_rareachievementstitle2 = /** @type {(inputs: Profile_Showcase_Rareachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`희귀 도전 과제`)
};

/**
* | output |
* | --- |
* | "Rare Achievements" |
*
* @param {Profile_Showcase_Rareachievementstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_rareachievementstitle2 = /** @type {((inputs?: Profile_Showcase_Rareachievementstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Rareachievementstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "ms") return ms_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "da") return da_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "de") return de_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "fil") return fil_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "fr") return fr_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "it") return it_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "hu") return hu_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "nl") return nl_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "no") return no_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "pl") return pl_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "pt") return pt_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "ro") return ro_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "fi") return fi_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "sv") return sv_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "vi") return vi_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "tr") return tr_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "cs") return cs_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "bg") return bg_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "ru") return ru_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "uk") return uk_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "ar") return ar_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "hi") return hi_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "th") return th_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "ja") return ja_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_rareachievementstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_rareachievementstitle2(inputs)
	return ko_profile_showcase_rareachievementstitle2(inputs)
});
export { profile_showcase_rareachievementstitle2 as "profile.showcase.rareAchievementsTitle" }